<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 16.09.2020
  -- Description : Liste des contacts depuis une entreprise
  -- Fichier : EntrepriseContactList.vue
  -->

<template>
  <v-card class="mx-auto" outlined>
    <v-list>
      <v-subheader>
        Derniers contacts
        <v-spacer></v-spacer>
        <CreateLastContact :typeEntrepriseId="entreprise.entrepriseId" />
      </v-subheader>
      <v-simple-table v-if="entreprise.lastContacts.length > 0">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Date</th>
              <th class="text-left">Nom</th>
              <th class="text-left">Remarques</th>
              <th class="text-left">Actions</th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in entreprise.lastContacts" :key="i">
              <td>
                {{ formatDate(item.dateOfContact) }}
              </td>
              <td>{{ item.name }}</td>
              <td>{{ displayRemarks(item.remarks) }}</td>
              <td>
                <EditLastContact
                  :lastContact="JSON.parse(JSON.stringify(item))"
                />
              </td>
              <td>
                <v-icon
                  color="red"
                  @click="deleteLastContact(item.lastContactId)"
                >
                  mdi-delete
                </v-icon>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-list>
  </v-card>
</template>

<script>
import store from '@/store/index.js'
import NProgress from 'nprogress'
import CreateLastContact from '@/components/CreateLastContact.vue'
import EditLastContact from '@/components/EditLastContact.vue'
import moment from 'moment'

export default {
  props: {
    entreprise: {
      type: Object,
      required: true
    }
  },

  components: {
    CreateLastContact,
    EditLastContact
  },

  methods: {
    // Supprime un contact
    deleteLastContact(contactId) {
      NProgress.start()
      store
        .dispatch('lastContact/deleteLastContact', {
          contactId
        })
        .then(() => {
          store.dispatch('entreprise/deleteLastContact', contactId)
        })
        .catch(() => {})
      this.dialog = false
      NProgress.done()
    },
    formatDate: function(date) {
      return moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD')
    },
    displayRemarks(text) {
      let maxCaracterToDisplay = 80
      return (
        text.slice(0, maxCaracterToDisplay) +
        (text.length > maxCaracterToDisplay ? '...' : '')
      )
    }
  }
}
</script>

<style></style>
